import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, shallowRef } from 'vue'
import FileUpload from '@/components/UploadFile/index.vue'
import { ElUploadInternalRawFile } from 'element-ui/types/upload'
import { UploadFileRes } from '@/api/common/common-api-type'
import { createTaskAPI, queryTypeAPI } from '@/api/mt/index'
import { Message } from 'element-ui'
import { languageMap } from './type'
import { ILanguageTypeRes } from '@/api/mt/type'
import { MessageBox } from 'element-ui'

interface IForm {
  fileId: string,
  language: string,
  fileList: UploadFileRes[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MtFile',
  emits: ['set-tab'],
  setup(__props, { emit: emits }) {

const fileUploadRef = shallowRef<InstanceType<typeof FileUpload>>()
const ruleForm = ref()
const form = ref<IForm>(resetForm())
function resetForm () {
  return {
    fileId: '',
    language: 'cn2en',
    fileList: []
  }
}
const rules = {
  language: [
    { required: true, message: '请选择翻译方向', trigger: 'blur' },
  ],
  fileList: [
    { required: true, message: '请上传文件', trigger: 'blur' },
  ]
}

const options = ref<ILanguageTypeRes[]>([])
async function getLanguageType () {
  const { data } = await queryTypeAPI()
  options.value = data
}
getLanguageType()

const loading = ref(false)
// 存在正在上传的文件
const hasLoading = computed(() => fileUploadRef.value?.hasLoading)
// 存在上传失败的文件
const hasFailUpload = computed(() => fileUploadRef.value?.hasFailUpload)
const taskCount = ref(0)

async function createTask () {
  await ruleForm.value.validate()
  // 任务额度为100条
  if (!judgeTaskCount(100)) return
  try {
    loading.value = true
    const { data } = await createTaskAPI({
      fileId: form.value.fileList.map(t => t.id).join(','),
      language: form.value.language
    })
    taskCount.value = taskCount.value + data.length
    fileUploadRef.value?.clearFiles()
    Message.success('创建成功')
    emits('set-tab', 'listMT')
  } catch (error) {
    console.log(error)
  } finally {
    loading.value = false
  }
}

function judgeTaskCount (maxNum: number) {
  let flag = true
  if (taskCount.value === maxNum) {
    flag = false
    MessageBox.confirm(`试用额度为${maxNum}条，剩余${maxNum - taskCount.value}条，无法继续翻译。`, '提示', {
      confirmButtonText: '确定',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
    }).catch(() => {})
  }
  if (taskCount.value < maxNum && taskCount.value + form.value.fileList.length > maxNum) {
    flag = false
    MessageBox.confirm(`试用额度为${maxNum}条，剩余${maxNum - taskCount.value}条，请调整上传文件后继续翻译。`, '提示', {
      confirmButtonText: '确定',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
    }).catch(() => {})
  }
  return flag
}

function beforeUploadFn (file: ElUploadInternalRawFile) {
  if (file.size === 0) {
    Message.error('文档内容为空')
    return false
  }
  return true
}

return { __sfc: true,fileUploadRef, ruleForm, form, resetForm, rules, options, getLanguageType, loading, hasLoading, hasFailUpload, taskCount, emits, createTask, judgeTaskCount, beforeUploadFn, FileUpload }
}

})